import { Text } from "../../ui-kit/Text/Text";

const content = [
  {
    type: 'header',
    content: "Дхарма",
  },
  {
    type: 'paragraph',
    content : `Дхарма есть движущее космическим порядком. В уме дхарма соответствует
    истине. Кто видит дхарму, тот говорит истину, тот творит дхарму.
    Диктатура пролетариата это время творящих дхарму.`
  },
  {
    type: 'title',
    content: "Правильные мысли"
  },
  {
    type: 'paragraph',
    content: `Кто видит дхарму, тот имеет правильные мысли относительно этого сражения, тот говорит истину, тот творит дхарму.`,
  },
  {
    type: 'title',
    content: "Сражение за виденье и творение дхармы",
  },
  {
    type: 'paragraph',
    content: `Время, датируемое как 1937 год, это начало открытого сражения с иблисами адхармы, творящими ложь и страдания, ввергающих в заблуждение. Иблисы адхармы сильны. Иблисы адхармы жестоки. Иблисы адхармы хитры. Иблисы адхармы любят рядиться в видящих дхарму. В страдании и превознеможении бились бодхисаттвы дхармы с иблисами адхармы. Иблисы умылись кровью бодхисаттв. Бодхисаттвы умылись кровью иблисов. Праведность, смирение и любовь сильнее корыстной лжи. Творящие дхарму бодхисаттвы победили.`,
  },
  {
    type: 'title',
    content: "DHARMA1937",
  },{
    type: 'paragraph',
    content: `DHARMA1937 существует, чтобы найти и направить будимых к истине, снимать пелену с взора, постигать дхарму и воплощать своё бодхичитта. Для того чтобы вновь и вновь наступало время творящих дхарму. Чтобы сансара разделения и отчуждения труда снялась в нирване по ту сторону отмирания государства через его усиление.`,
  },
  {
    type: 'title',
    content: "Самый тёмный час перед рассветом",
  },{
    type: 'paragraph',
    content: `Когда дхарма приходит в упадок и воцаряется адхарма, наступает время пробуждаться праведникам и уничтожить злодеев.`,
  },
  {
    type: 'image',
    content: "https://static.wixstatic.com/media/c62a6c_27d39417086e438a963ccb49540806d0~mv2.jpg/v1/fill/w_600,h_337,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/photo_2018-11-06_20-24-10.jpg"}
];

export const Dharma = () => {
  return (
    <>
      {content.map((el) => {
        switch (el.type) {
          case 'header':
            return(
              <Text header >
                {el.content}
              </Text>); break;
          case 'title':
            return(
              <Text title >
                {el.content}
              </Text>); break;
          case 'paragraph':
            return(
              <Text light>
                {el.content}
              </Text>); break;
          case 'image':
            return(<img src={el.content} style={{display: 'block', margin: '0 auto', width: '90%'}} />);
            break;
        }
      })}
    </>
  );
};
